/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useState } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import MediaQuery from 'react-responsive';
import { branch, renderComponent } from 'recompose';
import styled from 'styled-components';

import { device } from 'helpers/screenSizes';
import { tradingHaltedReason } from 'helpers/utils';
import { ChevronRightIcon, ChevronLeftIcon, ForwardIcon } from 'styles/assets/icons';

import {
  TickerPriceUnit,
  VolumeUnit,
  HighUnit,
  LowUnit,
  StrikePrice,
  dateFormat,
  NextFunding,
  SettlementUnit,
  MaturityUnit,
  NextFundingTicker,
  EstimatedFundingUnit,
  FundingUnit,
  KnockoutPriceUnit,
} from './tickerUnit';
// import { ProductToolTip } from './header-dropdown';

const Group1 = ({ product, lastTradePrice }) => {
  const { t } = useTranslation(['trading']);
  switch (product.contract_type) {
    case 'spreads':
      return (
        <GroupWrapper>
          <TickerPriceUnit
            label={`${t(`trading:lastPrice`)} (${product.quoting_asset.symbol})`}
            price={lastTradePrice}
            hasPriceMovement
            contract_type={product.contract_type}
          />
          <VolumeUnit product={product} />
          <MediaQuery query={device.up.lg}>
            <SettlementUnit product={product} />
          </MediaQuery>
          <HighUnit product={product} />
          <MediaQuery query={device.up.xl}>
            <LowUnit product={product} />
          </MediaQuery>
        </GroupWrapper>
      );
    case 'call_options':
    case 'put_options':
    case 'move_options':
      return (
        <GroupWrapper>
          <TickerPriceUnit
            label={`${t(`trading:lastPrice`)} (${product.quoting_asset.symbol})`}
            price={lastTradePrice}
            hasPriceMovement
            contract_type={product.contract_type}
          />
          <VolumeUnit product={product} />
          <StrikePrice product={product} />
          <MediaQuery query={device.up.lg}>
            <SettlementUnit product={product} />
          </MediaQuery>
          <MediaQuery query={device.up.xl}>
            <HighUnit product={product} />
            <LowUnit product={product} />
          </MediaQuery>
        </GroupWrapper>
      );
    case 'turbo_call_options':
    case 'turbo_put_options':
      return (
        <GroupWrapper>
          <MediaQuery query={device.up.md}>
            <TickerPriceUnit
              label={`${t(`trading:lastPrice`)} (${product.quoting_asset.symbol})`}
              price={lastTradePrice}
              hasPriceMovement
              contract_type={product.contract_type}
            />
            <VolumeUnit product={product} />
            <StrikePrice product={product} />
            <KnockoutPriceUnit product={product} />
          </MediaQuery>
          <MediaQuery query={device.down.md}>
            <TickerPriceUnit
              label={`${t(`trading:lastPrice`)} (${product.quoting_asset.symbol})`}
              price={lastTradePrice}
              hasPriceMovement
              contract_type={product.contract_type}
            />
            <VolumeUnit product={product} />
            <KnockoutPriceUnit product={product} />
          </MediaQuery>
        </GroupWrapper>
      );
    case 'interest_rate_swaps':
      return (
        <GroupWrapper>
          <TickerPriceUnit
            label={t(`trading:lastRate`)}
            price={lastTradePrice}
            hasPriceMovement
            contract_type={product.contract_type}
          />
          <VolumeUnit product={product} />
          <NextFunding />
          <MediaQuery query={device.up.lg}>
            <MaturityUnit product={product} />
          </MediaQuery>
          <MediaQuery query={device.up.xl}>
            <HighUnit product={product} />
            <LowUnit product={product} />
          </MediaQuery>
        </GroupWrapper>
      );
    case 'futures':
      return (
        <GroupWrapper>
          <TickerPriceUnit
            label={`${t(`trading:lastPrice`)}(${product.quoting_asset.symbol})`}
            price={lastTradePrice}
            hasPriceMovement
            contract_type={product.contract_type}
          />
          <VolumeUnit product={product} />
          <MediaQuery query={device.up.lg}>
            <SettlementUnit product={product} />
          </MediaQuery>
          <HighUnit product={product} />
          <MediaQuery query={device.up.xl}>
            <LowUnit product={product} />
          </MediaQuery>
        </GroupWrapper>
      );
    case 'perpetual_futures':
      return (
        <GroupWrapper>
          <MediaQuery query={device.up.md}>
            <TickerPriceUnit
              label={`${t(`trading:lastPrice`)} (${product.quoting_asset.symbol})`}
              price={lastTradePrice}
              hasPriceMovement
              contract_type={product.contract_type}
            />
            <VolumeUnit product={product} />
            <FundingUnit product={product} />
            <EstimatedFundingUnit product={product} />
          </MediaQuery>
          <MediaQuery query={device.down.md}>
            <TickerPriceUnit
              label={`${t(`trading:lastPrice`)} (${product.quoting_asset.symbol})`}
              price={lastTradePrice}
              hasPriceMovement
              contract_type={product.contract_type}
            />
            <VolumeUnit product={product} />
            <FundingUnit product={product} />
          </MediaQuery>
        </GroupWrapper>
      );
    case 'spot':
      return (
        <GroupWrapper>
          <TickerPriceUnit
            label={`${t(`trading:lastPrice`)} (${product.quoting_asset.symbol})`}
            price={lastTradePrice}
            hasPriceMovement
            contract_type={product.contract_type}
          />
          <VolumeUnit product={product} />
          <HighUnit product={product} />
          <LowUnit product={product} />
        </GroupWrapper>
      );
    default:
  }
};

const Group2 = ({ product }) => {
  switch (product.contract_type) {
    case 'spreads':
      return (
        <SecondGroupWrapper>
          <MediaQuery query={device.down.lg}>
            <LowUnit product={product} />
            <SettlementUnit product={product} />
          </MediaQuery>
          <MediaQuery query={device.up.lg}>
            <LowUnit product={product} />
          </MediaQuery>
        </SecondGroupWrapper>
      );
    case 'call_options':
    case 'put_options':
    case 'move_options':
      return (
        <SecondGroupWrapper>
          <MediaQuery query={device.down.lg}>
            <SettlementUnit product={product} />
            <HighUnit product={product} />
            <LowUnit product={product} />
          </MediaQuery>
          <MediaQuery query={device.up.lg}>
            <HighUnit product={product} />
            <LowUnit product={product} />
          </MediaQuery>
        </SecondGroupWrapper>
      );
    case 'turbo_call_options':
    case 'turbo_put_options':
      return (
        <SecondGroupWrapper>
          <MediaQuery query={device.up.md}>
            <SettlementUnit product={product} />
            <HighUnit product={product} />
            <LowUnit product={product} />
          </MediaQuery>
          <MediaQuery query={device.down.md}>
            <StrikePrice product={product} />
            <SettlementUnit product={product} />
          </MediaQuery>
        </SecondGroupWrapper>
      );
    case 'interest_rate_swaps':
      return (
        <SecondGroupWrapper>
          <MediaQuery query={device.down.lg}>
            <MaturityUnit product={product} />
            <HighUnit product={product} />
            <LowUnit product={product} />
          </MediaQuery>
          <MediaQuery query={device.up.lg}>
            <HighUnit product={product} />
            <LowUnit product={product} />
          </MediaQuery>
        </SecondGroupWrapper>
      );
    case 'futures':
      return (
        <SecondGroupWrapper>
          <MediaQuery query={device.down.lg}>
            <LowUnit product={product} />
            <SettlementUnit product={product} />
          </MediaQuery>
          <MediaQuery query={device.up.lg}>
            <LowUnit product={product} />
          </MediaQuery>
        </SecondGroupWrapper>
      );
    case 'perpetual_futures':
      return (
        <SecondGroupWrapper>
          <MediaQuery query={device.up.md}>
            <NextFundingTicker product={product} />
            <HighUnit product={product} />
            <LowUnit product={product} />
          </MediaQuery>

          <MediaQuery query={device.down.md}>
            <EstimatedFundingUnit product={product} />
            <NextFundingTicker product={product} />
          </MediaQuery>
        </SecondGroupWrapper>
      );
    default:
  }
};

const ToggleHeader = branch(
  ({ isOpen }) => isOpen,
  renderComponent(Group1),
  renderComponent(Group2)
)();

const ToggleIcon = branch(
  ({ isOpen }) => isOpen,
  renderComponent(ChevronRightIcon),
  renderComponent(ChevronLeftIcon)
)();

export const Header24hrChange = ({
  product,
  lastTradePrice,
  trading_status,
  Halted_label,
}) => {
  const { t } = useTranslation(['trading']);
  const [isOpen, setOpenState] = useState(true);
  const lastPrice = lastTradePrice || '-';
  const auctionTime = product.auction_finish_time
    ? dateFormat(product.auction_finish_time)
    : '-';

  const toggleHeader = () => {
    setOpenState(!isOpen);
  };

  const HeaderClass = classNames({
    ' col-xl-24 col-lg-24 col-md-24 col-sm-24 col-xxs-24 flex': true,
    '': !trading_status,
    'gradient-effect': trading_status,
  });

  const showToggleHeader = (() => {
    switch (product.contract_type) {
      case 'perpetual_futures':
      case 'turbo_put_options':
      case 'turbo_call_options':
        return true;
      default:
        return false;
    }
  })();

  return (
    (<HeaderWrapper className="d-flex header-data-group-desktop">
      <div className={HeaderClass}>
        {trading_status && Halted_label === 'Cancel' && (
          <>
            <MediaQuery query={device.up.lg}>
              <TickerPriceUnit
                label={`${t(`trading:lastPrice`)} (${product.quoting_asset.symbol})`}
                price={lastTradePrice}
                hasPriceMovement
                className="col-xxs-10 col-xs-7 col-md-11 col-lg-6 col-xl-6 col-xxl-4 initial-padding "
              />
            </MediaQuery>
            <HaLtedText className="col-xxs-24 col-xs-24 col-md-24 col-lg-18 col-xl-18 col-xxl-20 ">
              <div className="row justify-content-center">
                <p className="red-dot" />
                <span>
                  {' '}
                  {t('trading:tradingHalted')} ({tradingHaltedReason(product)}){' '}
                  {t('trading:in')} {product.symbol} - {Halted_label}{' '}
                  {t('trading:onlyMode')}
                </span>
              </div>
            </HaLtedText>
          </>
        )}

        {trading_status && Halted_label === 'Post' && (
          <AuctionTime>
            <div className="auction-item">
              <ForwardIcon />
            </div>
            <div className="auction-item auction-text">
              {t('trading:auctionInProgress')} - {Halted_label} {t('trading:onlyMode')}
            </div>
            <div className="auction-item vl" />
            <div className="auction-item auction-time">{auctionTime}</div>
          </AuctionTime>
        )}

        {!trading_status && showToggleHeader && (
          <>
            <div
              className="col-xl-22 col-lg-22 col-md-22 col-sm-22 col-xxs-22 flex"
              data-palette="Header24hrChange">
              <ToggleHeader
                isOpen={isOpen}
                product={product}
                lastTradePrice={lastPrice}
              />
            </div>
            {product.contract_type !== 'spot' && (
              <div
                data-testid="toggle-header"
                aria-hidden="true"
                className="col-lg-2 col-md-2 col-sm-2 col-xxs-2 icon"
                onClick={toggleHeader}
                data-palette="Header24hrChange">
                <ToggleIcon isOpen={isOpen} />
              </div>
            )}
          </>
        )}
        {!trading_status && !showToggleHeader && (
          <>
            <MediaQuery query={device.up.xl}>
              <div className="col-xl-24 col-lg-24 col-md-24 col-sm-24 col-xxs-24 flex">
                <ToggleHeader
                  isOpen={isOpen}
                  product={product}
                  lastTradePrice={lastPrice}
                />
              </div>
            </MediaQuery>

            <MediaQuery query={device.down.xl}>
              <div className="col-xl-22 col-lg-22 col-md-22 col-sm-22 col-xxs-22 flex">
                <ToggleHeader
                  isOpen={isOpen}
                  product={product}
                  lastTradePrice={lastPrice}
                />
              </div>
              {product.contract_type !== 'spot' && (
                <div
                  data-testid="toggle-header"
                  aria-hidden="true"
                  className="col-lg-2 col-md-2 col-sm-2 col-xxs-2 icon"
                  onClick={toggleHeader}
                  data-palette="Header24hrChange">
                  <ToggleIcon isOpen={isOpen} />
                </div>
              )}
            </MediaQuery>
          </>
        )}
      </div>
    </HeaderWrapper>)
  );
};

const HeaderWrapper = styled.div`
  width: 100%;
  .gradient-effect {
    background-image: linear-gradient(
      98deg,
      ${props => props.theme.primaryBackground}1A,
      ${props => props.theme.negative}1A
    );
    @media ${device.down.sm} {
      padding-top: 0px;
      padding-bottom: 0px;
    }
  }

  .flex {
    display: flex;
  }

  .icon {
    cursor: pointer;
    svg {
      margin-top: 8px;
    }
  }
`;

const HaLtedText = styled.div`
  font-family: var(--fontRegular);
  line-height: 1.25;
  letter-spacing: 0.6px;
  color: ${props => props.theme.primaryText};
  margin: auto;
  text-align: center;

  @media ${device.down.md} {
    font-size: 10px;
    display: flex;
    justify-content: center;
    height: 44px;

    span {
      margin: auto;
    }
  }

  @media ${device.up.md} {
    font-size: 10px;
  }

  @media ${device.up.lg} {
    font-size: 12.1px;
  }

  @media ${device.up.xl} {
    font-size: 14px;
  }

  .red-dot {
    margin: auto 0;
    margin-right: 10px;
    width: 10px;
    height: 10px;
    background-color: ${props => props.theme.negative};
    border-radius: 5px;
  }
`;

const GroupWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  @media ${device.down.md} {
    justify-content: space-around;
  }
`;

const SecondGroupWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: inherit;

  @media ${device.down.md} {
    justify-content: space-around;
    width: 100%;
  }
`;

const AuctionTime = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  width: 100%;
  height: 100%;

  .auction-item {
    margin-right: 10px;
    align-self: center;
  }

  .auction-text,
  .auction-time {
    font-family: var(--fontRegular);
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.6px;
    color: ${props => props.theme.secondaryText};
    align-self: center;
    padding-top: 5px;

    @media ${device.down.md} {
      font-size: 12.1px;
    }
  }

  .vl {
    border-left: solid 1px #414c5b;
    height: 26px;
    margin-top: 5px;
  }
`;
